import icAddSquare from 'assets/images/id-add-square.svg'
import Button from 'components/commons/button'
import FormModal from 'components/commons/form-modal'
import Table from 'components/commons/table'
import Toast from 'components/commons/toast'
import ViewList from 'components/commons/view-list'
import YearPicker from 'components/commons/yearpicker'
import { TABLE_DEVELOPMENT_SUMMARY_LIST } from 'configs/hr-metrics/configTableDevelopmentSummary'

export const DevelopmentSummaryList = ({
    dataList,
    isLoading,
    query,
    toast,
    modal,
    period,
    isLoadingCreate,
    clearToast,
    setShowModal,
    onChangeQuery,
    setPeriod,
    onCreatePeriod,
    onClickDetail,
}) => {
    return (
        <>
            <div className={'flex justify-between px-6 py-4 gap-3'}>
                <ViewList
                    show={modal?.limit}
                    onShow={() => setShowModal({ limit: true })}
                    onClose={() => setShowModal({ limit: false })}
                    value={query?.limit}
                    onSelectSize={(limit) => onChangeQuery({ page: 1, limit })}
                />
                <Button
                    title='Create Development Summary'
                    icon={icAddSquare}
                    onClick={() => setShowModal({ create: true })}
                />
            </div>
            <Table
                className='my-3'
                name={TABLE_DEVELOPMENT_SUMMARY_LIST.name}
                columns={TABLE_DEVELOPMENT_SUMMARY_LIST.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                onClickItem={onClickDetail}
            />

            <FormModal
                show={modal?.create}
                onHide={() => setShowModal({ create: false })}
                title={`Create Period`}
                onSubmitForm={onCreatePeriod}
                isLoading={isLoadingCreate}
                isDisabled={!period}
            >
                <div className={'px-8 py-6 mb-2 space-y-6'}>
                    <YearPicker
                        className={'flex-1'}
                        name='period'
                        value={period}
                        onChange={({ value }) => setPeriod(value)}
                    />
                </div>
            </FormModal>

            <Toast show={toast?.isShowToast} message={toast?.message} onClose={() => clearToast()} />
        </>
    )
}
